import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faEnvelope,
  faArrowAltCircleRight,
  faClose,
} from '@fortawesome/free-solid-svg-icons';
import ReactApexChart from 'react-apexcharts';

import { useMyContext } from '../../../..';
import { Trans } from 'react-i18next';

//=============redux============
import { useSelector, useDispatch } from 'react-redux';
import {
  getAllBusinessDTP,
  getAllBusinesses,
  getOneBusiness,
} from '../../../../redux/auth/authSlice';

import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import api from '../../../../utility/api';
import moment from 'moment';
import { Button } from 'react-bootstrap';
// import "./main.css";

import { format } from 'date-fns';

//======Utils
const verificationCode = process.env.REACT_APP_VERIFICATION_TOKEN;
const BASE_URL_IMAGES = process.env.REACT_APP_BASE_URL_IMAGE;

const Main = () => {
  const { language, setLanguage } = useMyContext();
  const dispatch = useDispatch();

  const { allBusinessDTP, allBusinessData } = useSelector((state) => {
    return state.auth;
  });

  //==========All business datatouchPoints================================
  const [businessId, setBusinessId] = useState('');
  useEffect(() => {
    dispatch(
      getAllBusinessDTP({
        verificationCode,
        dtpIds: multiDtp,
        businessID: businessId,
        selectedButton: selectedButton,
      })
    );
    dispatch(getAllBusinesses({ verificationCode }));
  }, [dispatch]);
  //==========Get Business Data on Main Dashboard================================
  //================Global Business search suggustion======================
  //==========Employee Sentiment & Customer Feedback Selection===========
  const [selectedButton, setSelectedButton] = useState('');
  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName);
  };

  const [searchItem, setSearchItem] = useState('');
  const [selectedCompany, setSelectedCompany] = useState('');
  const [optionsSearch, setOptionsSearch] = useState([]);
  const companyLoading = optionsSearch.length === 0;
  const onChangeData = (e) => {
    if (e.target.value.length > 1) {
      setTimeout(async () => {
        const res = await api.post('/business/globalCompanySearch', {
          verificationCode,
          string: e.target.value,
        });
        if (res.data) {
          const formatData = [];
          if (res.data.length !== 0) {
            res.data.map((item) =>
              formatData.push({
                id: item._id,
                name: item.name_of_business,
                email: item.email,
                image: item.logo,
              })
            );
          }

          if (formatData.length !== 0) {
            setOptionsSearch(formatData);
          }
        }
      }, 500);
    }
    setSearchItem(e.target.value);
    setSelectedCompany(''); // Clear selectedCompany when typing in the input
  };

  useEffect(() => {
    if (searchItem === '') {
      setBusinessId('');
    }
  }, [searchItem]);
  //===============DataTouchPoint change =============================
  const [dtpId, setDTPId] = useState('');

  //=======================Google Map cities as well creating new cities coordinated alex map

  const MapContainer = ({ cityCoordinates }) => {
    const mapRef = useRef(null);

    useEffect(() => {
      if (cityCoordinates && cityCoordinates.length !== 0) {
        const loadMapScript = () => {
          if (!window.google || !window.google.maps || !mapRef.current) {
            const script = document.createElement('script');
            // script.src = `https://maps.googleapis.com/maps/api/js?key=${
            //   process.env.REACT_APP_GOOGLE_MAP_KEY
            // }&callback=initMap`;
            // script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCAmVYL3WPlOgib6t-e79DJbUs8dRWzjYY&callback=initMap`;
            script.async = true;
            script.defer = true;
            window.initMap = initMap;
            document.body.appendChild(script);
          } else {
            initMap();
          }
        };

        const initMap = () => {
          const map = new window.google.maps.Map(mapRef.current, {
            center: { lat: 40.4637, lng: -3.7492 }, // Default center coordinates
            zoom: 3,
          });

          cityCoordinates &&
            cityCoordinates.forEach((city) => {
              const marker = new window.google.maps.Marker({
                position: { lat: city.lat, lng: city.lng },
                map: map,
                title: city,
              });
            });
        };

        loadMapScript();
      }
    }, [cityCoordinates]);

    return <div ref={mapRef} style={{ height: '100%', width: '100%' }}></div>;
  };

  function MapComponent() {
    const [cityCoordinates, setCityCoordinates] = useState([]);

    // useEffect(() => {
    //   const geocoder = new window.google.maps.Geocoder();

    //   const fetchCoordinates = async () => {
    //     const coordinates = await Promise.all(
    //       allBusinessDTP &&
    //         allBusinessDTP?.npsData?.map(async (cityName) => {
    //           return new Promise((resolve) => {
    //             geocoder.geocode(
    //               { address: cityName.city },
    //               (results, status) => {
    //                 if (status === "OK") {
    //                   resolve({
    //                     name:
    //                       cityName.city +
    //                       " " +
    //                       `(${cityName.npsLast30Days?.npsLast30Days.toFixed(
    //                         0
    //                       )} NPS)`,
    //                     lat: results[0].geometry.location.lat(),
    //                     lng: results[0].geometry.location.lng(),
    //                   });
    //                 } else {
    //                   resolve(null);
    //                 }
    //               }
    //             );
    //           });
    //         })
    //     );

    //     setCityCoordinates(coordinates.filter((coord) => coord !== null));
    //   };

    //   const fetchSpecificCoordinates = async () => {
    //     const coordinates = await Promise.all(
    //       allBusinessDTP &&
    //         allBusinessDTP?.npsData
    //           .filter((dtp) => dtp.business === businessId)
    //           ?.map(async (cityName) => {
    //             return new Promise((resolve) => {
    //               geocoder.geocode(
    //                 { address: cityName.city },
    //                 (results, status) => {
    //                   if (status === "OK") {
    //                     resolve({
    //                       name:
    //                         cityName.city +
    //                         " " +
    //                         `(${cityName.npsLast30Days?.npsLast30Days.toFixed(
    //                           0
    //                         )} NPS)`,
    //                       lat: results[0].geometry.location.lat(),
    //                       lng: results[0].geometry.location.lng(),
    //                     });
    //                   } else {
    //                     resolve(null);
    //                   }
    //                 }
    //               );
    //             });
    //           })
    //     );

    //     setCityCoordinates(coordinates.filter((coord) => coord !== null));
    //   };

    //   if (businessId !== "") {
    //     fetchSpecificCoordinates();
    //   } else {
    //     fetchCoordinates();
    //   }
    // }, [allBusinessDTP?.dataTouchPoints, businessId]);

    return (
      <>
        {cityCoordinates && <MapContainer cityCoordinates={cityCoordinates} />}
      </>
    );
  }

  //===========Map load END=======================================================

  //==============================================START OF LAST 30 DAYS AND YTD DONUT GRAPH

  //=====================Doughout Chart js START======================//
  const [thirtyDaysNPS, setThirtyDaysNPS] = useState();
  const [color30Days, setColor30Days] = useState();

  //<Trans>Year</Trans> to Date
  const [ytdNPS, setYTDNPS] = useState();
  const [colorYTDNPS, setColorYTDNPS] = useState();

  // let thirtyDaySeries = [];
  let [thirtyDaySeries, setThirtyDaySeries] = useState([]);
  let [thirtyDaysLabels, setThirtyDaysLabels] = useState([]);

  //=====YEAR to Date NPS ===========
  let [YTDSeries, setYTDSeries] = useState([]);
  let [YTDLabels, setYTDLabels] = useState([]);

  let totalPromotersSum = 0;
  let totalPassivesSum = 0;
  let totalDetractorsSum = 0;

  //==<Trans>Year</Trans> to Date NPS
  let totalPromotersYTDSum = 0;
  let totalPassivesYTDSum = 0;
  let totalDetractorsYTDSum = 0;

  //useeffect dealing with selected buttons.
  // console.log('allBusinessDTP', allBusinessDTP);
  useEffect(() => {
    if (selectedButton) {
      const selectedtypeDTPs = allBusinessDTP?.npsData?.filter(
        (dataTouchPoint) => dataTouchPoint?.type === selectedButton
      );

      if (selectedtypeDTPs && selectedtypeDTPs.length > 0) {
        selectedtypeDTPs.forEach((selectedDTP) => {
          const { npsLast30Days, npsYearToDate } = selectedDTP;

          const {
            totalPromotersLast30Days,
            totalPassivesLast30Days,
            totalDetractorsLast30Days,
          } = npsLast30Days;

          totalPromotersSum += totalPromotersLast30Days;
          totalPassivesSum += totalPassivesLast30Days;
          totalDetractorsSum += totalDetractorsLast30Days;

          //++++ Calculate the percentages and set values to array series values YEAR TO DATE START++
          const {
            totalPromotersYearToDate,
            totalPassivesYearToDate,
            totalDetractorsYearToDate,
          } = npsYearToDate;

          totalPromotersYTDSum += totalPromotersYearToDate;
          totalPassivesYTDSum += totalPassivesYearToDate;
          totalDetractorsYTDSum += totalDetractorsYearToDate;

          //+++++++NPS For <Trans>Year</Trans> to date
          let totalReviewYTD =
            totalPromotersYTDSum + totalPassivesYTDSum + totalDetractorsYTDSum;

          let promotersYTDPercentage =
            (totalPromotersYTDSum / totalReviewYTD) * 100;
          let detractorsYTDPercentage =
            (totalDetractorsYTDSum / totalReviewYTD) * 100;

          // Calculate the NPS
          let npsLastYTD = promotersYTDPercentage - detractorsYTDPercentage;

          if (npsLastYTD != undefined) {
            if (npsLastYTD >= 30) {
              setColorYTDNPS('#41E998'); // Green for NPS >= 30
            } else if (npsLastYTD >= -30) {
              setColorYTDNPS('#F5A623');
            } else {
              setColorYTDNPS('#E84949');
            }
          }

          setYTDNPS(npsLastYTD);

          let YTDArr = [];

          YTDArr.push(
            totalPromotersYTDSum,
            totalPassivesYTDSum,
            totalDetractorsYTDSum
          );
          if (YTDArr?.length > 0) setYTDSeries(YTDArr);

          //-----Labels YTD-----

          let YTDLabelsArr = [];

          let totalPromoters1 =
            parseInt(totalPromotersYTDSum) / parseInt(totalReviewYTD);
          let totalPassives1 =
            parseInt(totalPassivesYTDSum) / parseInt(totalReviewYTD);
          let totalDetractors1 =
            parseInt(totalDetractorsYTDSum) / parseInt(totalReviewYTD);

          YTDLabelsArr.push(
            `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
              parseFloat(totalPromoters1 ? totalPromoters1 : 0) * 100
            ).toFixed(1)}% | ${totalPromotersYTDSum}`,
            `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
              parseFloat(totalPassives1 ? totalPassives1 : 0) * 100
            ).toFixed(1)}% | ${totalPassivesYTDSum}`,
            `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
              parseFloat(totalDetractors1 ? totalDetractors1 : 0) * 100
            ).toFixed(1)}% | ${totalDetractorsYTDSum}`
          );

          setYTDLabels(YTDLabelsArr);

          //++++ Calculate the percentages and set values to array series values YEAR TO DATE END++

          //++++ Calculate the percentages and set values to array series values 30 DAYS START++
          //+++++++NPS For last 30 Days

          let totalReviewLast30Days =
            totalPromotersSum + totalPassivesSum + totalDetractorsSum;

          let promotersPercentage =
            (totalPromotersSum / totalReviewLast30Days) * 100;
          let detractorsPercentage =
            (totalDetractorsSum / totalReviewLast30Days) * 100;

          // Calculate the NPS
          let npsLast30ds = promotersPercentage - detractorsPercentage;
          if (npsLast30ds != undefined) {
            if (npsLast30ds >= 30) {
              setColor30Days('#41E998'); // Green for NPS >= 30
            } else if (npsLast30ds >= -30) {
              setColor30Days('#F5A623');
            } else {
              setColor30Days('#E84949');
            }
          }
          setThirtyDaysNPS(npsLast30ds);

          let thirtyDayArr = [];

          thirtyDayArr.push(
            totalPromotersSum,
            totalPassivesSum,
            totalDetractorsSum
          );
          if (thirtyDayArr?.length > 0) setThirtyDaySeries(thirtyDayArr);

          //-----Labels 30 days-----

          let thirtyDayLabelsArr = [];
          let totalPromoter =
            parseInt(totalPromotersSum) / parseInt(totalReviewLast30Days);
          let totalPassives =
            parseInt(totalPassivesSum) / parseInt(totalReviewLast30Days);
          let totalDetractors =
            parseInt(totalDetractorsSum) / parseInt(totalReviewLast30Days);
          thirtyDayLabelsArr.push(
            `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
              parseFloat(totalPromoter ? totalPromoter : 0) * 100
            ).toFixed(1)}% | ${totalPromotersSum}`,
            `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
              parseFloat(totalPassives ? totalPassives : 0) * 100
            ).toFixed(1)}% | ${totalPassivesSum}`,
            `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
              parseFloat(totalDetractors ? totalDetractors : 0) * 100
            ).toFixed(1)}% | ${totalDetractorsSum}`
          );
          setThirtyDaysLabels(thirtyDayLabelsArr);
          //++++ Calculate the percentages and set values to array series values 30 DAYS END++
        });
      }
    }
    if (businessId) {
      const selectedDTPs = allBusinessDTP?.npsData?.filter(
        (dataTouchPoint) => dataTouchPoint?.business == businessId
      );
      let allTop5Reasons = [];
      for (let i = 0; i < selectedDTPs?.length; i++) {
        if (selectedDTPs[i]?.top5Reasons?.length > 0) {
          let updatedBarSeries = selectedDTPs[i]?.top5Reasons
            .slice(0, 5)
            .map((reason) => ({
              name: reason.name,
              data: reason.data,
            }));
          allTop5Reasons = allTop5Reasons.concat(updatedBarSeries);
        }
      }
      setBarSeries(allTop5Reasons);
      if (selectedDTPs && selectedDTPs.length > 0) {
        selectedDTPs.forEach((selectedDTP) => {
          const { npsLast30Days, npsYearToDate } = selectedDTP;

          const {
            totalPromotersLast30Days,
            totalPassivesLast30Days,
            totalDetractorsLast30Days,
          } = npsLast30Days;

          totalPromotersSum += totalPromotersLast30Days;
          totalPassivesSum += totalPassivesLast30Days;
          totalDetractorsSum += totalDetractorsLast30Days;

          //++++ Calculate the percentages and set values to array series values YEAR TO DATE START++
          const {
            totalPromotersYearToDate,
            totalPassivesYearToDate,
            totalDetractorsYearToDate,
          } = npsYearToDate;

          totalPromotersYTDSum += totalPromotersYearToDate;
          totalPassivesYTDSum += totalPassivesYearToDate;
          totalDetractorsYTDSum += totalDetractorsYearToDate;

          //+++++++NPS For <Trans>Year</Trans> to date
          let totalReviewYTD =
            totalPromotersYTDSum + totalPassivesYTDSum + totalDetractorsYTDSum;

          let promotersYTDPercentage =
            (totalPromotersYTDSum / totalReviewYTD) * 100;
          let detractorsYTDPercentage =
            (totalDetractorsYTDSum / totalReviewYTD) * 100;

          // Calculate the NPS
          let npsLastYTD = promotersYTDPercentage - detractorsYTDPercentage;

          if (npsLastYTD != undefined) {
            if (npsLastYTD >= 30) {
              setColorYTDNPS('#41E998'); // Green for NPS >= 30
            } else if (npsLastYTD >= -30) {
              setColorYTDNPS('#F5A623');
            } else {
              setColorYTDNPS('#E84949');
            }
          }

          setYTDNPS(npsLastYTD);

          let YTDArr = [];

          YTDArr.push(
            totalPromotersYTDSum,
            totalPassivesYTDSum,
            totalDetractorsYTDSum
          );
          if (YTDArr?.length > 0) setYTDSeries(YTDArr);

          //-----Labels YTD-----

          let YTDLabelsArr = [];

          let totalPromoters1 =
            parseInt(totalPromotersYTDSum) / parseInt(totalReviewYTD);
          let totalPassives1 =
            parseInt(totalPassivesYTDSum) / parseInt(totalReviewYTD);
          let totalDetractors1 =
            parseInt(totalDetractorsYTDSum) / parseInt(totalReviewYTD);

          YTDLabelsArr.push(
            `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
              parseFloat(totalPromoters1 ? totalPromoters1 : 0) * 100
            ).toFixed(1)}% | ${totalPromotersYTDSum}`,
            `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
              parseFloat(totalPassives1 ? totalPassives1 : 0) * 100
            ).toFixed(1)}% | ${totalPassivesYTDSum}`,
            `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
              parseFloat(totalDetractors1 ? totalDetractors1 : 0) * 100
            ).toFixed(1)}% | ${totalDetractorsYTDSum}`
          );

          setYTDLabels([...YTDLabelsArr]);

          //++++ Calculate the percentages and set values to array series values YEAR TO DATE END++

          //++++ Calculate the percentages and set values to array series values 30 DAYS START++
          //+++++++NPS For last 30 Days
          let totalReviewLast30Days =
            totalPromotersSum + totalPassivesSum + totalDetractorsSum;

          let promotersPercentage =
            (totalPromotersSum / totalReviewLast30Days) * 100;
          let detractorsPercentage =
            (totalDetractorsSum / totalReviewLast30Days) * 100;

          // Calculate the NPS
          let npsLast30ds = promotersPercentage - detractorsPercentage;
          if (npsLast30ds != undefined) {
            if (npsLast30ds >= 30) {
              setColor30Days('#41E998'); // Green for NPS >= 30
            } else if (npsLast30ds >= -30) {
              setColor30Days('#F5A623');
            } else {
              setColor30Days('#E84949');
            }
          }
          setThirtyDaysNPS(npsLast30ds);

          let thirtyDayArr = [];

          thirtyDayArr.push(
            totalPromotersSum,
            totalPassivesSum,
            totalDetractorsSum
          );
          if (thirtyDayArr?.length > 0) setThirtyDaySeries(thirtyDayArr);

          //-----Labels 30 days-----

          let thirtyDayLabelsArr = [];
          let totalPromoters =
            parseInt(totalPromotersSum) / parseInt(totalReviewLast30Days);
          let totalPassives =
            parseInt(totalPassivesSum) / parseInt(totalReviewLast30Days);
          let totalDetractors =
            parseInt(totalDetractorsSum) / parseInt(totalReviewLast30Days);

          thirtyDayLabelsArr.push(
            `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
              parseFloat(totalPromoters ? totalPromoters : 0) * 100
            ).toFixed(1)}% | ${totalPromotersSum}`,
            `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
              parseFloat(totalPassives ? totalPassives : 0) * 100
            ).toFixed(1)}% | ${totalPassivesSum}`,
            `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
              parseFloat(totalDetractors ? totalDetractors : 0) * 100
            ).toFixed(1)}% | ${totalDetractorsSum}`
          );
          setThirtyDaysLabels(thirtyDayLabelsArr);
          //++++ Calculate the percentages and set values to array series values 30 DAYS END++
        });
      }
    } else {
      // Iterate through each data touchpoint in npsData
      allBusinessDTP?.npsData &&
        allBusinessDTP?.npsData?.forEach((dataTouchPoint) => {
          const { npsLast30Days, npsYearToDate } = dataTouchPoint;

          const {
            totalPromotersLast30Days,
            totalPassivesLast30Days,
            totalDetractorsLast30Days,
          } = npsLast30Days;

          totalPromotersSum += totalPromotersLast30Days;
          totalPassivesSum += totalPassivesLast30Days;
          totalDetractorsSum += totalDetractorsLast30Days;

          // Calculate the series data for  YTD the chart
          const {
            totalPromotersYearToDate,
            totalPassivesYearToDate,
            totalDetractorsYearToDate,
          } = npsYearToDate;

          totalPromotersYTDSum += totalPromotersYearToDate;
          totalPassivesYTDSum += totalPassivesYearToDate;
          totalDetractorsYTDSum += totalDetractorsYearToDate;
        });
      //++++ Calculate the percentages and set values to array series values YEAR TO DATE START++
      //+++++++NPS For <Trans>Year</Trans> to date
      let totalReviewYTD =
        totalPromotersYTDSum + totalPassivesYTDSum + totalDetractorsYTDSum;

      let promotersYTDPercentage =
        (totalPromotersYTDSum / totalReviewYTD) * 100;
      let detractorsYTDPercentage =
        (totalDetractorsYTDSum / totalReviewYTD) * 100;

      // Calculate the NPS
      let npsLastYTD = promotersYTDPercentage - detractorsYTDPercentage;

      if (npsLastYTD) {
        if (npsLastYTD >= 30) {
          setColorYTDNPS('#41E998'); // Green for NPS >= 30
        } else if (npsLastYTD >= -30) {
          setColorYTDNPS('#F5A623');
        } else {
          setColorYTDNPS('#E84949');
        }
      }

      setYTDNPS(npsLastYTD);

      let YTDArr = [];

      YTDArr.push(
        totalPromotersYTDSum,
        totalPassivesYTDSum,
        totalDetractorsYTDSum
      );
      if (YTDArr?.length > 0) setYTDSeries(YTDArr);

      //-----Labels YTD-----

      let YTDLabelsArr = [];

      let totalPromoters =
        parseInt(totalPromotersYTDSum) / parseInt(totalReviewYTD);
      let totalPassives =
        parseInt(totalPassivesYTDSum) / parseInt(totalReviewYTD);
      let totalDetractors =
        parseInt(totalDetractorsYTDSum) / parseInt(totalReviewYTD);
      YTDLabelsArr.push(
        `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
          parseFloat(totalPromoters ? totalPromoters : 0) * 100
        ).toFixed(1)}% | ${totalPromotersYTDSum}`,
        `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
          parseFloat(totalPassives ? totalPassives : 0) * 100
        ).toFixed(1)}% | ${totalPassivesYTDSum}`,
        `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
          parseFloat(totalDetractors ? totalDetractors : 0) * 100
        ).toFixed(1)}% | ${totalDetractorsYTDSum}`
      );

      setYTDLabels(YTDLabelsArr);
      //++++ Calculate the percentages and set values to array series values YEAR TO DATE END++

      //++++ Calculate the percentages and set values to array series values 30 DAYS START++
      //+++++++NPS For last 30 Days
      let totalReviewLast30Days =
        totalPromotersSum + totalPassivesSum + totalDetractorsSum;

      let promotersPercentage =
        (totalPromotersSum / totalReviewLast30Days) * 100;
      let detractorsPercentage =
        (totalDetractorsSum / totalReviewLast30Days) * 100;

      // Calculate the NPS
      let nps = promotersPercentage - detractorsPercentage;
      if (nps != undefined) {
        if (nps >= 30) {
          setColor30Days('#41E998'); // Green for NPS >= 30
        } else if (nps >= -30) {
          setColor30Days('#F5A623');
        } else {
          setColor30Days('#E84949');
        }
      }

      setThirtyDaysNPS(nps);

      let thirtyDayArr = [];

      thirtyDayArr.push(
        totalPromotersSum,
        totalPassivesSum,
        totalDetractorsSum
      );
      if (thirtyDayArr?.length > 0) setThirtyDaySeries(thirtyDayArr);

      //-----Labels 30 days-----

      let thirtyDayLabelsArr = [];

      let totalPromoters1 =
        parseInt(totalPromotersSum) / parseInt(totalReviewLast30Days);
      let totalPassives1 =
        parseInt(totalPassivesSum) / parseInt(totalReviewLast30Days);
      let totalDetractors1 =
        parseInt(totalDetractorsSum) / parseInt(totalReviewLast30Days);

      thirtyDayLabelsArr.push(
        `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
          parseFloat(totalPromoters1 ? totalPromoters1 : 0) * 100
        ).toFixed(1)}% | ${totalPromotersSum}`,
        `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
          parseFloat(totalPassives1 ? totalPassives1 : 0) * 100
        ).toFixed(1)}% | ${totalPassivesSum}`,
        `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
          parseFloat(totalDetractors1 ? totalDetractors1 : 0) * 100
        ).toFixed(1)}% | ${totalDetractorsSum}`
      );
      setThirtyDaysLabels(thirtyDayLabelsArr);
      //++++ Calculate the percentages and set values to array series values 30 DAYS END++
    }
  }, [thirtyDaysNPS, ytdNPS, allBusinessDTP, businessId, selectedButton]);

  const optionsLast30d = {
    chart: {
      type: 'donut',
      // width: "200px",
      // height: "200px",
      borderWidth: 15,
    },
    colors: ['#41E998', '#A2A39E', '#E84949'],
    stroke: {
      width: 0,
      lineCap: 'round',
    },
    labels: thirtyDaysLabels,
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true, // Hide the "Total" text
              formatter: function () {
                return `${thirtyDaysNPS ? thirtyDaysNPS.toFixed(0) : 0}`;
              },
            },
            value: {
              fontSize: '45px',
              fontWeight: 'bold',
              offsetY: 15,
              color: color30Days,
            },
            name: {
              show: false,
              fontSize: '10px',
              offsetY: -0,
              color: '#000',
            },
          },
          size: '85%',
        },
        spacing: 1,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 280,
          },
          legend: {
            position: 'bottom',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
      {
        breakpoint: 9999,
        options: {
          chart: {
            height: 350,
            width: 350,
          },
          legend: {
            position: 'right',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
    ],
    dataLabels: {
      style: {
        fontSize: '0px',
        fontFamily: 'Poppins, sans-serif',
      },
    },
  };

  const optionsYTD = {
    chart: {
      type: 'donut',
      // width: "200px",
      // height: "200px",
      borderWidth: 15,
    },
    colors: ['#41E998', '#A2A39E', '#E84949'],
    stroke: {
      width: 0,
      lineCap: 'round',
    },
    labels: YTDLabels,
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true, // Hide the "Total" text
              formatter: function (val) {
                return `${ytdNPS ? ytdNPS.toFixed(0) : 0}`; // Display the NPS value with a percentage symbol
              },
            },
            value: {
              fontSize: '45px',
              fontWeight: 'bold',
              offsetY: 15,
              color: colorYTDNPS,
            },
            name: {
              show: false,
              fontSize: '10px',
              offsetY: -0,
              color: '#000',
            },
          },
          size: '85%',
        },
        spacing: 1,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 280,
          },
          legend: {
            position: 'bottom',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
      {
        breakpoint: 9999,
        options: {
          chart: {
            height: 350,
            width: 350,
          },
          legend: {
            position: 'right',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
    ],
    dataLabels: {
      style: {
        fontSize: '0px',
        fontFamily: 'Poppins, sans-serif',
      },
    },
  };

  //==============================================END OF LAST 30 DAYS AND YTD DONUT GRAPH

  //===================================Select Multiple DTP START===============================
  const [multiDtp, setMultiDtp] = useState([]);
  const [multiDtpData, setMultiDtpData] = useState();
  const handleMultiDtpSelection = (e) => {
    const options = e.map((item) => ({
      value: item.value,
      label: item.label,
    }));

    setMultiDtp(options);
  };

  useEffect(() => {
    if (multiDtp) {
      getData();
    }
  }, [multiDtp, selectedButton]);

  const getData = async () => {
    try {
      const response = await api.post('/review/getMultiDtpData', {
        verificationCode,
        dtpIds: multiDtp,
        businessID: businessId,
        selectedButton: selectedButton,
      });
      // console.log(
      //   'response------------------------------------------>>>>>>>>>>>>',
      //   response?.data
      // );
      if (response?.data) setMultiDtpData(response?.data);
    } catch (error) {}
  };

  useEffect(() => {
    return () => {};
  }, []);

  //===================================Select Multiple DTP END===============================

  //=====================Big Doughout Chart======================//
  let [sevenDaySeries, setSevenDaysSeries] = useState([]);
  let [sevenDayLabels, setSevenDaysLabels] = useState([]);
  const [sevenDayNPS, setSevenDayNPS] = useState();
  const [colorSevenDayNPS, setColorSevenDayNPS] = useState();

  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: '',
  });

  const { startDate, endDate } = dateRange;

  useEffect(() => {
    // console.log('allsbusinessDTP', allBusinessDTP);
    const startDateLast7Days = new Date();
    startDateLast7Days.setDate(startDateLast7Days.getDate() - 6);

    let positivesCountLast7Days = 0;
    let passivesCountLast7Days = 0;
    let negativesCountLast7Days = 0;

    let filteredBdtp = allBusinessDTP?.npsData;

    if (multiDtp?.length) {
      filteredBdtp = filteredBdtp?.filter((bdtp) => {
        return multiDtp.some((item) => item.label === bdtp.name);
      });
    }

    filteredBdtp
      ?.filter((Bdtp) => businessId === '' || Bdtp?.business === businessId)
      .forEach((Bdtp) => {
        Bdtp.reviews.forEach((review) => {
          const reviewDate = new Date(review.createdAt); // Assuming review.createdAt is the review date
          if (reviewDate >= startDateLast7Days) {
            if (review.rating === 3) {
              positivesCountLast7Days++;
            } else if (review.rating === 2) {
              passivesCountLast7Days++;
            } else if (review.rating === 1) {
              negativesCountLast7Days++;
            }
          }
        });
      });

    if (selectedButton && selectedButton !== '') {
      filteredBdtp
        ?.filter((Bdtp) => Bdtp?.type === selectedButton)
        .forEach((Bdtp) => {
          Bdtp.reviews.forEach((review) => {
            const reviewDate = new Date(review.createdAt); // Assuming review.createdAt is the review date
            if (reviewDate >= startDateLast7Days) {
              if (review.rating === 3) {
                positivesCountLast7Days++;
              } else if (review.rating === 2) {
                passivesCountLast7Days++;
              } else if (review.rating === 1) {
                negativesCountLast7Days++;
              }
            }
          });
        });
    }

    let overAll7ds =
      positivesCountLast7Days +
      passivesCountLast7Days +
      negativesCountLast7Days;

    let promoters7DsPercentage = (positivesCountLast7Days / overAll7ds) * 100;
    let detractors7DsPercentage = (negativesCountLast7Days / overAll7ds) * 100;

    // Calculate the NPS of 7 Days
    let npsLast7Ds = promoters7DsPercentage - detractors7DsPercentage;
    if (npsLast7Ds != undefined) {
      if (npsLast7Ds >= 30) {
        setColorSevenDayNPS('#41E998'); // Green for NPS >= 30
      } else if (npsLast7Ds >= -30) {
        setColorSevenDayNPS('#F5A623');
      } else {
        setColorSevenDayNPS('#E84949');
      }
    }

    setSevenDayNPS(npsLast7Ds);

    setSevenDaysSeries([
      positivesCountLast7Days,
      passivesCountLast7Days,
      negativesCountLast7Days,
    ]);

    let totalPromoters1 =
      parseInt(positivesCountLast7Days) / parseInt(overAll7ds);
    let totalPassives1 =
      parseInt(passivesCountLast7Days) / parseInt(overAll7ds);
    let totalDetractors1 =
      parseInt(negativesCountLast7Days) / parseInt(overAll7ds);

    setSevenDaysLabels([
      `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
        parseFloat(totalPromoters1 ? totalPromoters1 : 0) * 100
      ).toFixed(1)}% | ${positivesCountLast7Days}`,
      `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
        parseFloat(totalPassives1 ? totalPassives1 : 0) * 100
      ).toFixed(1)}% | ${passivesCountLast7Days}`,
      `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
        parseFloat(totalDetractors1 ? totalDetractors1 : 0) * 100
      ).toFixed(1)}% | ${negativesCountLast7Days}`,
    ]);

    let npsOverAllData = 0;
    let multiDataPassives = 0;
    let multiDtpNps = 0;
    if (multiDtpData && multiDtpData?.reviewsInfo.length !== 0) {
      npsOverAllData =
        multiDtpData &&
        multiDtpData?.totalPositive +
          multiDtpData?.totalNeutral +
          multiDtpData?.totalNegative;

      multiDataPassives = (multiDtpData?.totalPositive / npsOverAllData) * 100;
      let multiDataDetractor =
        (multiDtpData?.totalNegative / npsOverAllData) * 100;

      multiDtpNps = multiDataPassives - multiDataDetractor;
    }

    if (multiDtpData != undefined && multiDtpData?.reviewsInfo.length !== 0) {
      if (!isNaN(multiDtpNps)) {
        setSevenDayNPS(multiDtpNps);
      } else {
        setSevenDayNPS(0);
      }

      if (multiDtpNps >= 30) {
        setColorSevenDayNPS('#41E998'); // Green for NPS >= 30
      } else if (multiDtpNps >= -30) {
        setColorSevenDayNPS('#F5A623');
      } else {
        setColorSevenDayNPS('#E84949');
      }

      setSevenDaysSeries([
        multiDtpData?.totalPositive,
        multiDtpData?.totalNeutral,
        multiDtpData?.totalNegative,
      ]);

      let totalPromoters1 =
        parseInt(multiDtpData?.totalPositive) / parseInt(npsOverAllData);
      let totalPassives1 =
        parseInt(multiDtpData?.totalNeutral) / parseInt(npsOverAllData);
      let totalDetractors1 =
        parseInt(multiDtpData?.totalNegative) / parseInt(npsOverAllData);

      setSevenDaysLabels([
        `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
          parseFloat(totalPromoters1 ? totalPromoters1 : 0) * 100
        ).toFixed(1)}% | ${multiDtpData?.totalPositive}`,
        `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
          parseFloat(totalPassives1 ? totalPassives1 : 0) * 100
        ).toFixed(1)}% | ${multiDtpData?.totalNeutral}`,
        `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
          parseFloat(totalDetractors1 ? totalDetractors1 : 0) * 100
        ).toFixed(1)}% | ${multiDtpData?.totalNegative}`,
      ]);
    }
  }, [
    allBusinessDTP,
    sevenDayNPS,
    businessId,
    multiDtpData,
    selectedButton,
    multiDtp,
  ]);

  const optionsLast7Days = {
    chart: {
      type: 'donut',
      // width: "200px",
      // height: "200px",
      borderWidth: 15,
    },
    colors: ['#41E998', '#A2A39E', '#E84949'],
    stroke: {
      width: 0,
      lineCap: 'round',
    },
    labels: sevenDayLabels,
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true, // Hide the "Total" text
              formatter: function (val) {
                return `
                ${sevenDayNPS ? sevenDayNPS.toFixed(0) : 0}`; // Display the NPS value with a percentage symbol
              },
            },
            value: {
              fontSize: '45px',
              fontWeight: 'bold',
              offsetY: 15,
              color: colorSevenDayNPS,
            },
            name: {
              show: false,
              fontSize: '10px',
              offsetY: -0,
              color: '#000',
            },
          },
          size: '85%',
        },
        spacing: 1,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 280,
          },
          legend: {
            position: 'bottom',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
      {
        breakpoint: 9999,
        options: {
          chart: {
            height: 350,
            width: 350,
          },
          legend: {
            position: 'right',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
    ],
    dataLabels: {
      style: {
        fontSize: '0px',
        fontFamily: 'Poppins, sans-serif',
      },
    },
  };

  //=========Range Selected NPS====================START
  let [rangeSeries, setRangeSeries] = useState([]); // Initialize as empty array
  let [rangeLabels, setRangeLabels] = useState([]); // Initialize as empty array
  const [rangeDayNPS, setRangeDayNPS] = useState();
  const [colorRangeNPS, setColorRangeNPS] = useState();

  const [minEndDate, setMinEndDate] = useState('');

  async function getDataNPSGraph(id) {
    try {
      const response = await api.post('/review/getMultiDtpData', {
        verificationCode,
        dtpIds: multiDtp,
        businessID: id,

        selectedButton: selectedButton,
      });
      if (response?.data) setMultiDtpData(response?.data);
    } catch (error) {}
  }

  const handleRangeChange = (e) => {
    const { name, value } = e.target;
    if (name === 'startDate') {
      setMinEndDate(value);
    }
    setDateRange({ ...dateRange, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    if (startDate && endDate && multiDtpData?.reviewsInfo.length === 0) {
      const rangeStartDate = new Date(startDate);
      const rangeEndDate = new Date(endDate);
      rangeEndDate.setDate(rangeEndDate.getDate() + 1);

      let positivesCountRange = 0;
      let passivesCountRange = 0;
      let negativesCountRange = 0;

      let filteredBdtp = allBusinessDTP?.npsData;

      if (multiDtp?.length) {
        filteredBdtp = filteredBdtp?.filter((bdtp) => {
          return multiDtp.some((item) => item.label === bdtp.name);
        });
      }

      filteredBdtp
        ?.filter((Bdtp) => businessId === '' || Bdtp?.business === businessId)
        .forEach((Bdtp) => {
          Bdtp.reviews.forEach((review) => {
            const reviewDate = new Date(review.createdAt); // Assuming review.createdAt is the review date
            if (reviewDate >= rangeStartDate && reviewDate < rangeEndDate) {
              if (review.rating === 3) {
                positivesCountRange++;
              } else if (review.rating === 2) {
                passivesCountRange++;
              } else if (review.rating === 1) {
                negativesCountRange++;
              }
            }
          });
        });

      if (selectedButton && selectedButton !== '') {
        filteredBdtp
          ?.filter((Bdtp) => Bdtp?.type === selectedButton)
          .forEach((Bdtp) => {
            Bdtp.reviews.forEach((review) => {
              const reviewDate = new Date(review.createdAt); // Assuming review.createdAt is the review date
              if (reviewDate >= rangeStartDate && reviewDate < rangeEndDate) {
                if (review.rating === 3) {
                  positivesCountRange++;
                } else if (review.rating === 2) {
                  passivesCountRange++;
                } else if (review.rating === 1) {
                  negativesCountRange++;
                }
              }
            });
          });
      }

      const overAllRange =
        positivesCountRange + passivesCountRange + negativesCountRange;

      let promotersRangePercentage = (positivesCountRange / overAllRange) * 100;
      let detractorsRangePercentage =
        (negativesCountRange / overAllRange) * 100;

      // Calculate the NPS of Range selected Days
      let npsRangeSelected =
        promotersRangePercentage - detractorsRangePercentage;
      if (npsRangeSelected != undefined) {
        if (npsRangeSelected >= 30) {
          setColorRangeNPS('#41E998'); // Green for NPS >= 30
        } else if (npsRangeSelected >= -30) {
          setColorRangeNPS('#F5A623');
        } else {
          setColorRangeNPS('#E84949');
        }
      }

      setRangeDayNPS(npsRangeSelected);

      setRangeSeries([
        positivesCountRange,
        passivesCountRange,
        negativesCountRange,
      ]);

      let totalPromoters1 =
        parseInt(positivesCountRange) / parseInt(overAllRange);
      let totalPassives1 =
        parseInt(passivesCountRange) / parseInt(overAllRange);
      let totalDetractors1 =
        parseInt(negativesCountRange) / parseInt(overAllRange);

      setRangeLabels([
        `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
          parseFloat(totalPromoters1 ? totalPromoters1 : 0) * 100
        ).toFixed(1)}% | ${positivesCountRange}`,
        `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
          parseFloat(totalPassives1 ? totalPassives1 : 0) * 100
        ).toFixed(1)}% | ${passivesCountRange}`,
        `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
          parseFloat(totalDetractors1 ? totalDetractors1 : 0) * 100
        ).toFixed(1)}% | ${negativesCountRange}`,
      ]);
    }

    let npsOverAllData = 0;
    let multiDataPassives = 0;
    let multiDtpNps = 0;
    if (multiDtpData && multiDtpData?.reviewsInfo.length !== 0) {
      npsOverAllData =
        multiDtpData &&
        multiDtpData?.totalPositive +
          multiDtpData?.totalNeutral +
          multiDtpData?.totalNegative;

      multiDataPassives = (multiDtpData?.totalPositive / npsOverAllData) * 100;
      let multiDataDetractor =
        (multiDtpData?.totalNegative / npsOverAllData) * 100;

      multiDtpNps = multiDataPassives - multiDataDetractor;
    }

    if (multiDtpData != undefined && multiDtpData?.reviewsInfo.length !== 0) {
      if (!isNaN(multiDtpNps)) {
        setRangeDayNPS(multiDtpNps);
      } else {
        setRangeDayNPS(0);
      }

      if (multiDtpNps >= 30) {
        setColorRangeNPS('#41E998'); // Green for NPS >= 30
      } else if (multiDtpNps >= -30) {
        setColorRangeNPS('#F5A623');
      } else {
        setColorRangeNPS('#E84949');
      }

      setRangeSeries([
        multiDtpData?.totalPositive,
        multiDtpData?.totalNeutral,
        multiDtpData?.totalNegative,
      ]);

      let totalPromoters1 =
        parseInt(multiDtpData?.totalPositive) / parseInt(npsOverAllData);
      let totalPassives1 =
        parseInt(multiDtpData?.totalNeutral) / parseInt(npsOverAllData);
      let totalDetractors1 =
        parseInt(multiDtpData?.totalNegative) / parseInt(npsOverAllData);

      setRangeLabels([
        `${language === 'en' ? 'Promoters' : 'Promotoras'}\n${(
          parseFloat(totalPromoters1 ? totalPromoters1 : 0) * 100
        ).toFixed(1)}% | ${multiDtpData?.totalPositive}`,
        `${language === 'en' ? 'Passives' : 'Pasivos'}\n${(
          parseFloat(totalPassives1 ? totalPassives1 : 0) * 100
        ).toFixed(1)}% | ${multiDtpData?.totalNeutral}`,
        `${language === 'en' ? 'Detractors' : 'Detractoras'}\n${(
          parseFloat(totalDetractors1 ? totalDetractors1 : 0) * 100
        ).toFixed(1)}% | ${multiDtpData?.totalNegative}`,
      ]);
    }
  }, [
    startDate,
    endDate,
    allBusinessDTP,
    businessId,
    rangeDayNPS,
    multiDtpData,
    selectedButton,
    multiDtp,
  ]);

  const optionsSelectedRange = {
    chart: {
      type: 'donut',
      // width: "200px",
      // height: "200px",
      borderWidth: 15,
    },
    colors: ['#41E998', '#A2A39E', '#E84949'],
    stroke: {
      width: 0,
      lineCap: 'round',
    },
    labels: rangeLabels,
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true, // Hide the "Total" text
              formatter: function (val) {
                return `${rangeDayNPS ? rangeDayNPS.toFixed(0) : 0}`;
              },
            },
            value: {
              fontSize: '45px',
              fontWeight: 'bold',
              offsetY: 15,
              color: colorRangeNPS,
            },
            name: {
              show: false,
              fontSize: '10px',
              offsetY: -0,
              color: '#000',
            },
          },
          size: '85%',
        },
        spacing: 1,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 280,
          },
          legend: {
            position: 'bottom',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
      {
        breakpoint: 9999,
        options: {
          chart: {
            height: 350,
            width: 350,
          },
          legend: {
            position: 'right',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
    ],
    dataLabels: {
      style: {
        fontSize: '0px',
        fontFamily: 'Poppins, sans-serif',
      },
    },
  };

  //=====================Doughout Chart js END======================//

  //---------------===========Tree Map chart ---------==================//
  const [barSeries, setBarSeries] = useState([]);

  useEffect(() => {
    let updatedBarSeries = [];
    if (
      multiDtpData &&
      multiDtp.length > 0 &&
      multiDtpData?.reviewsInfo.length !== 0
    ) {
      // If a multi DTP is selected, update the barSeries using the selectedDTP's top5Reasons
      updatedBarSeries =
        multiDtpData &&
        multiDtpData?.top5Reasons.slice(0, 5).map((reason) => ({
          name: reason.name,
          data: reason.data,
        }));
      setBarSeries(updatedBarSeries);
    } else if (
      multiDtp.length === 0 &&
      selectedButton &&
      selectedButton !== ''
    ) {
      const selectedBusinessNPSData = allBusinessDTP?.npsData?.filter(
        (dataTouchPoint) => dataTouchPoint.type === selectedButton
      );

      if (selectedBusinessNPSData && selectedBusinessNPSData.length > 0) {
        const overallTop5Reasons = selectedBusinessNPSData.reduce(
          (acc, dataTouchPoint) => {
            dataTouchPoint.top5Reasons.forEach((reason) => {
              const existingReason = acc.find((r) => r.name === reason.name);
              if (existingReason) {
                existingReason.data = existingReason.data.map(
                  (value, index) => value + reason.data[index]
                );
              } else {
                acc.push({ name: reason.name, data: [...reason.data] });
              }
            });
            return acc;
          },
          []
        );
        updatedBarSeries = overallTop5Reasons.slice(0, 5);
        setBarSeries(updatedBarSeries);
      }
    } else {
      // If no specific DTP is selected, update the barSeries using overall top5Reasons
      const overallTop5Reasons = allBusinessDTP?.npsData?.reduce(
        (acc, dataTouchPoint) => {
          dataTouchPoint.top5Reasons.forEach((reason) => {
            const existingReason = acc.find((r) => r.name === reason.name);
            if (existingReason) {
              existingReason.data = existingReason.data.map(
                (value, index) => value + reason.data[index]
              );
            } else {
              acc.push({
                name: reason.name,
                data: reason.data,
                review: reason?.review,
              });
            }
          });
          return acc;
        },
        []
      );
      const selectedDtps = multiDtp?.map((item) => item?.value);
      updatedBarSeries = overallTop5Reasons
        ?.filter((item) => selectedDtps?.includes(item?.review?.DataTouchPoint))
        ?.slice(0, 5);
      // updatedBarSeries = overallTop5Reasons?.slice(0, 5);
      setBarSeries(updatedBarSeries);
    }
  }, [allBusinessDTP?.npsData, multiDtpData, selectedButton]);
  const [barOptions] = useState({
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      stackType: '100%',
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 280,
          },
          legend: {
            position: 'bottom',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          total: {
            enabled: false, // Disable the total dataLabels
          },
        },
      },
    },
    xaxis: {
      categories: [
        language === 'en' ? 'Promoters' : 'Promotoras',
        language === 'en' ? 'Passives' : 'Pasivos',
        language === 'en' ? 'Detractors' : 'Detractoras',
      ], // Adjust the categories
      labels: {
        show: true, // Hide x-axis labels
      },
    },
    yaxis: {
      show: false, // Hide the vertical axis
    },
    legend: {
      show: true,
      position: 'right',
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
    grid: {
      show: false, // Hide gridlines
    },
  });

  //---------------===========Tree Map chart ---------==================//

  //====================Line Chart alex=======================//

  const [timeFrameLabel, setTimeFrameLabel] = useState([]);
  const [timeFrameData, setTimeFrameData] = useState([]);
  const [compTimeFrameData, setCompTimeFrameData] = useState([]);
  const [filterData, setFilterData] = useState('daily');

  useEffect(() => {
    if (multiDtp !== undefined) {
      if (
        multiDtpData &&
        multiDtpData?.result?.hourWiseNps &&
        filterData === 'hour'
      ) {
        setTimeFrameLabel(multiDtpData?.result?.hourWiseNps?.name);
        setTimeFrameData(multiDtpData?.result?.hourWiseNps?.data);
      }
      if (
        multiDtpData &&
        multiDtpData?.result?.dayWiseNps &&
        filterData === 'daily'
      ) {
        setTimeFrameLabel(multiDtpData?.result?.dayWiseNps?.name);
        setTimeFrameData(multiDtpData?.result?.dayWiseNps?.data);
      }
      if (
        multiDtpData &&
        multiDtpData?.result?.weekWiseNps &&
        filterData === 'week'
      ) {
        setTimeFrameLabel(multiDtpData?.result?.weekWiseNps?.name);
        setTimeFrameData(multiDtpData?.result?.weekWiseNps?.data);
      }
      if (
        multiDtpData &&
        multiDtpData?.result?.monthWiseNps &&
        filterData === 'month'
      ) {
        setTimeFrameLabel(multiDtpData?.result?.monthWiseNps?.name);
        setTimeFrameData(multiDtpData?.result?.monthWiseNps?.data);
      }
      if (
        multiDtpData &&
        multiDtpData?.result?.yearWiseNps &&
        filterData === 'year'
      ) {
        setTimeFrameLabel(multiDtpData?.result?.yearWiseNps?.name);
        setTimeFrameData(multiDtpData?.result?.yearWiseNps?.data);
      }
      //+++++++COmpany
      if (multiDtpData && multiDtpData?.companyResult) {
        if (
          multiDtpData &&
          multiDtpData?.companyResult?.hourWiseNps &&
          filterData === 'hour'
        ) {
          setTimeFrameLabel(multiDtpData?.companyResult?.hourWiseNps?.name);
          setCompTimeFrameData(multiDtpData?.companyResult?.hourWiseNps?.data);
        }

        if (
          multiDtpData &&
          multiDtpData?.companyResult?.dayWiseNps &&
          filterData === 'daily'
        ) {
          setTimeFrameLabel(multiDtpData?.companyResult?.dayWiseNps?.name);
          setCompTimeFrameData(multiDtpData?.companyResult?.dayWiseNps?.data);
        }
        if (
          multiDtpData &&
          multiDtpData?.companyResult?.weekWiseNps &&
          filterData === 'week'
        ) {
          setTimeFrameLabel(multiDtpData?.companyResult?.weekWiseNps?.name);
          setCompTimeFrameData(multiDtpData?.companyResult?.weekWiseNps?.data);
        }
        if (
          multiDtpData &&
          multiDtpData?.companyResult?.monthWiseNps &&
          filterData === 'month'
        ) {
          setTimeFrameLabel(multiDtpData?.companyResult?.monthWiseNps?.name);
          setCompTimeFrameData(multiDtpData?.companyResult?.monthWiseNps?.data);
        }
        if (
          multiDtpData &&
          multiDtpData?.companyResult?.yearWiseNps &&
          filterData === 'year'
        ) {
          setTimeFrameLabel(multiDtpData?.companyResult?.yearWiseNps?.name);
          setCompTimeFrameData(multiDtpData?.companyResult?.yearWiseNps?.data);
        }
      }
    }
  }, [multiDtpData, filterData]);

  const [benchmarkNPSData, setbenchmarkNPSData] = useState();
  const [BenchmarkData, setBenchmarkData] = useState();

  useEffect(() => {
    // console.log('allbusinessDtp', allBusinessDTP);
    if (allBusinessDTP) {
      const data =
        allBusinessDTP?.benchMarkData &&
        allBusinessDTP?.benchMarkData?.map((item) => {
          return {
            label: item.name,
            data: item.npsData.map((dataPoint) => dataPoint.overAllNps),
            // borderColor: getRandomColor(),
            // backgroundColor: getRandomColor(),
            hidden: false,
          };
        });

      // const updatedData = benchmarkNPSData.map((dataSet) => ({
      //   name: dataSet.label,
      //   data: timeFrameLabel.map((label, index) => ({
      //     x: label,
      //     y: dataSet.data[index],
      //   })),
      // }));
      // // Set the state with the updated array
      // setBenchmarkData(updatedData);
      setbenchmarkNPSData(data);
    }
    return () => {};
  }, [allBusinessDTP, businessId]);

  // function getRandomColor() {
  //   const letters = "0123456789ABCDEF";
  //   let color = "#";
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // }
  //=================CHART==========
  const chartOptions = {
    chart: {
      type: 'line',
      height: 350,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 4, // Set the line width
    },
    xaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: true,
      },
      labels: {
        style: {
          colors: '#8e8da4',
        },
        offsetY: -7,
        offsetX: 0,
      },
    },
    yaxis: {
      min: -100,
      max: 100,
      tickAmount: 10, // You can adjust the number of ticks as needed
      labels: {
        style: {
          colors: '#8e8da4',
        },
        offsetY: -7,
        offsetX: 0,
        formatter: function (value) {
          if (value !== undefined) {
            return value.toFixed(0); // Ensure no decimal points
          }
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },

    fill: {
      opacity: 1,
    },
    tooltip: {
      x: {
        format: 'HH:mm', // Tooltip format for the x-axis
      },
      fixed: {
        enabled: false,
        position: 'topRight',
      },
    },
    grid: {
      show: false,
      yaxis: {
        lines: {
          offsetX: -30,
        },
      },
      padding: {
        left: 10,
      },
    },
  };

  // const convertToLocalTimeZone = (dateString) => {
  //   const date = new Date(dateString);
  //   const options = {
  //     year: 'numeric',
  //     month: '2-digit',
  //     day: '2-digit',
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     hour12: false,
  //     timeZone: 'UTC', // Make sure to specify the timezone of the input date string
  //   };
  //   const localDateString = date.toLocaleDateString('en-US', options);
  //   const localTimeString = date.toLocaleTimeString('en-US', options);
  //   return `${localTimeString}`;
  // };
  const convertToLocalTimeZone = (date) => {
    const localDate = new Date(date); // Convert to local time zone
    if (filterData === 'hour') {
      return format(localDate, 'dd-MM-yyyy HH', {
        useAdditionalWeekYearTokens: true,
      });
    } else {
      return format(localDate, 'dd-MM-yyyy HH:mm', {
        useAdditionalWeekYearTokens: true,
      });
    }
  };

  // console.log('time frame data', timeFrameData);
  // Format your data for different datasets

  // const benchmarkData = benchmarkNPSData?.map((dataSet) => ({
  //   name: dataSet.label,      // console.log(
  //   'response------------------------------------------>>>>>>>>>>>>',
  //   response?.data
  // );
  //   data: timeFrameLabel.map((label, index) => ({
  //     x: label,
  //     y: dataSet.data[index],
  //   })),
  // }));

  // console.log('before chart', multiDtp);

  const [chartSeries, setChartSeries] = useState([]);
  const [southData, setSouthData] = useState({});
  const [northData, setNorthData] = useState({});
  useEffect(() => {
    const uniqueDataMap = new Map();

    // Determine the slice index based on the length of timeFrameLabel
    const sliceIndex = Math.max(0, timeFrameLabel.length - 10);

    // Iterate over the timeFrameLabel and filter out duplicate x values
    for (let i = 0; i < timeFrameLabel.length; i++) {
      const x = convertToLocalTimeZone(timeFrameLabel[i]);
      const northY = timeFrameData[i];
      const southY = compTimeFrameData[i];

      if (!uniqueDataMap.has(x)) {
        // If x value is not encountered before, add it to the map
        uniqueDataMap.set(x, {
          x: x,
          northY: northY,
          southY: southY,
        });
      }
    }

    // Extract the unique data from the map
    const uniqueDataArray = Array.from(uniqueDataMap.values());

    // Separate northData and southData arrays
    const uniqueNorthData = uniqueDataArray.map((data) => ({
      x: data.x,
      y: data.northY,
    }));
    const uniqueSouthData = uniqueDataArray.map((data) => ({
      x: data.x,
      y: data.southY,
    }));

    // Set the unique data arrays for northData and southData
    setNorthData(uniqueNorthData);
    setSouthData(uniqueSouthData);
  }, [compTimeFrameData, timeFrameData, timeFrameLabel]);

  useEffect(() => {
    setChartSeries([
      {
        name: (multiDtp?.length !== 0 && multiDtp?.map((d) => d?.label)) || '',
        data: northData,
      },
      {
        name: 'Selected Business',
        data: southData,
      },
      ...(Array.isArray(BenchmarkData) ? BenchmarkData : []), // Ensure benchmarkData is an array
    ]);
  }, [northData, southData, BenchmarkData]);

  // const chartSeries = [
  //   {
  //     name: (multiDtp?.length !== 0 && multiDtp.map((d) => d.label)) || '',
  //     data: northData,
  //   },
  //   {
  //     name: 'Selected Business',
  //     data: southData,
  //   },
  //   ...(Array.isArray(BenchmarkData) ? BenchmarkData : []), // Ensure benchmarkData is an array
  // ];

  useEffect(() => {
    handleButtonClick('Customer Experience');
    return () => {};
  }, []);

  return (
    <>
      <div className="container-fluid py-3">
        <div className="row g-3">
          <div className="col-md-6">
            <input
              type="text"
              placeholder="Search Business"
              className="dashboardinput w-100"
              value={selectedCompany || searchItem}
              onChange={onChangeData}
              loading={companyLoading}
            />
            <FontAwesomeIcon icon={faSearch} className="dashboardIcon" />
          </div>
          <div className="col-md-3">
            <button
              type="button"
              className={`w-100 btn btn-dash w-100 text-nowrap rounded-pill   ${
                selectedButton === 'Customer Experience' ? 'selected' : ''
              }`}
              onClick={() => handleButtonClick('Customer Experience')}
            >
              <Trans>CustomerExperience</Trans>
            </button>
          </div>
          <div className="col-md-3">
            <button
              type="button"
              className={`w-100 btn btn-dash text-nowrap w-100   rounded-pill  ${
                selectedButton === 'Employee Sentiment' ? 'selected' : ''
              }`}
              onClick={() => handleButtonClick('Employee Sentiment')}
            >
              <Trans>EmployeeSentiment</Trans>
            </button>
          </div>
        </div>
        <h6 className="dashboard  fw-500 d-flex align-items-center mt-2">
          <Trans>Dashboard</Trans>
        </h6>
        {searchItem && (
          <div>
            {optionsSearch ? (
              optionsSearch?.map((data, idx) => (
                <div key={idx} className="d-flex">
                  <div
                    className="d-flex dropBorder p-2"
                    onClick={() => {
                      getDataNPSGraph(data?.id);
                      setBusinessId(data?.id);
                      setSelectedCompany(data?.name); // Set the selected company's name
                      setOptionsSearch([]); // Close the dropdown here
                    }}
                  >
                    <img
                      src={BASE_URL_IMAGES + data?.image}
                      alt="Logo"
                      onError={(e) => (e.target.src = '/assets/user.png')}
                      className="rounded-circle mt-2"
                      style={{
                        width: '40px',
                        height: '40px',
                        textAlign: 'center',
                      }}
                    />
                    <div className="ms-2 mt-2">
                      <h6 className="dropHeadin">{data?.name} ...</h6>
                      <p className="m-0 text-dark">
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          className="mapIcon"
                        />{' '}
                        {data?.email}
                      </p>
                    </div>
                  </div>
                  <Link
                    to={`/admin/businessDetail/${data?.id}`}
                    className="detailsIcon"
                  >
                    <FontAwesomeIcon
                      icon={faArrowAltCircleRight}
                      className="detailsIconStyle"
                    />{' '}
                  </Link>
                </div>
              ))
            ) : (
              <>
                <h2>No Item Found</h2>
              </>
            )}
          </div>
        )}
        <div className="row my-2">
          <div className="col-md-6 col-lg-6 mb-2">
            <div className="chart-div card shadow-sm">
              <div className="card-header">
                <h5 className="mb-0">
                  <Trans>NPS Last 30 days</Trans>
                </h5>
              </div>
              <div
                id="chart"
                className="small-chart card-body p-1 OverFlow  mx-auto mt-1"
              >
                <ReactApexChart
                  options={optionsLast30d}
                  series={thirtyDaySeries}
                  type="donut"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 mb-2">
            <div className="card-body">
              <div className="chart-div card shadow-sm">
                <div className="card-header">
                  <h5 className="mb-0">
                    <Trans>NPS YTD</Trans>
                  </h5>
                </div>
                <div
                  id="chart"
                  className="small-chart card-body OverFlow p-1  mx-auto mt-1"
                >
                  <ReactApexChart
                    options={optionsYTD}
                    series={YTDSeries}
                    type="donut"
                  />
                </div>
              </div>
            </div>
          </div>

          <hr className="mt-3" />
        </div>

        {/* //=====Filter Date Range and Multi Select DTP ===== */}
        <div className="row mb-2">
          <div className="col-12 col-md-6 mb-2">
            <div className="mob-flex" id="filer">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="date"
                    className="form-control "
                    name="startDate"
                    value={startDate}
                    onChange={handleRangeChange}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="date"
                    className="form-control "
                    name="endDate"
                    value={endDate}
                    min={minEndDate}
                    onChange={handleRangeChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 mb-2">
            {multiDtp && (
              <Select
                id="multiple-select-field"
                isMulti
                options={
                  allBusinessDTP &&
                  allBusinessDTP?.npsData
                    ?.filter(
                      (Bdtp) =>
                        businessId === '' || Bdtp?.business === businessId
                    )
                    .map((Bdtp) => ({
                      label: Bdtp.name,
                      value: Bdtp.dataTouchPointId,
                    }))
                }
                onChange={handleMultiDtpSelection}
                // value={multiDtp}
              />
            )}
          </div>
        </div>

        {/* //=====Filter Date Range and Multi Select DTP END===== */}

        <div className="row">
          <div className="col-md-6 mb-2">
            <div className="card p-0 card-height shadow-sm">
              <div className="card-header">
                <h4 className="mb-0">
                  {' '}
                  <Trans>NPS</Trans>
                </h4>
              </div>
              <div className="card-body">
                {startDate && (
                  <h6>
                    {' '}
                    {startDate &&
                      endDate &&
                      moment(startDate).format('DD-MM-YYYY') +
                        ' -- ' +
                        moment(endDate).format('DD-MM-YYYY')}{' '}
                  </h6>
                )}
                <div
                  id="chart"
                  className="small-chart card-body p-1 mx-auto mt-md-5 mt-0"
                >
                  {startDate && endDate ? (
                    <ReactApexChart
                      options={optionsSelectedRange}
                      series={rangeSeries}
                      type="donut"
                    />
                  ) : (
                    <ReactApexChart
                      options={optionsLast7Days}
                      series={sevenDaySeries}
                      type="donut"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="card p-0 card-height shadow-sm">
              <div className="card-header">
                <h4 className="mb-0">
                  {' '}
                  <Trans>Reason of votes</Trans>{' '}
                </h4>
              </div>
              <div className="card-body">
                <div
                  id="Treechart"
                  className="small-chart card-body OverFlow p-1  mx-auto mt-1"
                >
                  <ReactApexChart
                    options={barOptions}
                    series={barSeries}
                    type="bar"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Graph and Map */}
        <div className="row my-3">
          {/* <div className="col-12 col-md-6 mb-2">
            <div className="card card-height-btm shadow-sm">
              <div className="card-header">
                <h5 className="mb-0">Data Touchpoint Location</h5>
              </div>
              <div className="card-body">
                <div className="map-container">
                  <MapComponent />
                </div>
              </div>
            </div>
          </div> */}
          <div className="col-12 col-md-12 mb-2">
            <div className="card card-height-btm shadow-sm">
              <div className="card-header mb-0">
                <div className="mbl-graph ">
                  <div>
                    <h5 className="mb-0">
                      <Trans>NPS Evolution</Trans>
                    </h5>
                  </div>
                  <div>
                    <div className="d-flex justify-content-center gap-2">
                      <button
                        onClick={() => setFilterData('hour')}
                        className={
                          filterData === 'hour'
                            ? 'btn-chart active'
                            : 'btn-chart'
                        }
                      >
                        <Trans>Hour</Trans>
                      </button>
                      <button
                        onClick={() => setFilterData('daily')}
                        className={
                          filterData === 'daily'
                            ? 'btn-chart active'
                            : 'btn-chart'
                        }
                      >
                        <Trans>Day</Trans>
                      </button>
                      <button
                        onClick={() => setFilterData('week')}
                        className={
                          filterData === 'week'
                            ? 'btn-chart active'
                            : 'btn-chart'
                        }
                      >
                        <Trans>Week</Trans>
                      </button>
                      <button
                        onClick={() => setFilterData('month')}
                        className={
                          filterData === 'month'
                            ? 'btn-chart active'
                            : 'btn-chart'
                        }
                      >
                        <Trans>Month</Trans>
                      </button>
                      <button
                        onClick={() => setFilterData('year')}
                        className={
                          filterData === 'year'
                            ? 'btn-chart active'
                            : 'btn-chart'
                        }
                      >
                        <Trans>Year</Trans>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                {timeFrameLabel?.length > 0 && (
                  <div className="mbl-top">
                    <ReactApexChart
                      options={chartOptions}
                      series={chartSeries}
                      type="line"
                      height={350}
                    />

                    {/* <Line options={optionsChart} data={data} /> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
